export type VacationCardTone = 'neutral' | 'info' | 'danger' | 'warning' | 'primary' | 'success';

export const CARD_TONE_CLASSES: Record<VacationCardTone, string> = {
    neutral: 'bg-raro-gray-100 border-raro-gray-200 hover:border-raro-gray-300 hover:shadow-sm',
    info: 'bg-sky-50 border-sky-100 hover:border-sky-200 hover:shadow-sm',
    danger: 'bg-red-50 border-red-100 hover:border-red-200 hover:shadow-sm',
    warning: 'bg-amber-50 border-amber-100 hover:border-amber-200 hover:shadow-sm',
    primary: 'bg-primary-50 border-primary-100 hover:border-primary-200 hover:shadow-sm',
    success: 'bg-emerald-50 border-emerald-100 hover:border-emerald-200 hover:shadow-sm',
};

export const CARD_ICON_WRAP_CLASSES: Record<VacationCardTone, string> = {
    neutral: 'bg-raro-gray-300 text-raro-gray-700',
    info: 'bg-sky-200 text-sky-700',
    danger: 'bg-red-200 text-red-700',
    warning: 'bg-amber-200 text-amber-700',
    primary: 'bg-primary-200 text-primary-700',
    success: 'bg-emerald-200 text-emerald-700',
};

export const CARD_LABEL_CLASSES: Record<VacationCardTone, string> = {
    neutral: 'text-raro-gray-500',
    info: 'text-sky-700',
    danger: 'text-red-700',
    warning: 'text-amber-700',
    primary: 'text-primary-700',
    success: 'text-emerald-700',
};

export const CARD_VALUE_CLASSES: Record<VacationCardTone, string> = {
    neutral: 'text-raro-gray-900',
    info: 'text-sky-700',
    danger: 'text-red-700',
    warning: 'text-amber-700',
    primary: 'text-primary-700',
    success: 'text-emerald-700',
};

export const CARD_ACTIVE_CLASSES: Record<VacationCardTone, string> = {
    neutral: 'ring-2 ring-raro-gray-400 bg-raro-gray-200 border-transparent',
    info: 'ring-2 ring-sky-400 bg-sky-100 border-transparent',
    danger: 'ring-2 ring-red-400 bg-red-100 border-transparent',
    warning: 'ring-2 ring-amber-400 bg-amber-100 border-transparent',
    primary: 'ring-2 ring-primary-400 bg-primary-100 border-transparent',
    success: 'ring-2 ring-emerald-400 bg-emerald-100 border-transparent',
};

export const CARD_FOCUS_CLASSES =
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500';
